import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimWorkOrderChangeObjectSelectionDataFilterInput } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderChangeObjectSelectionListGql } from '../bimWorkOrderChangeStructureQueries';

const requestId = 'bimWorkOrderChangeObjectSelectionList';

export const useBimWorkOrderChangeObjectSelectionList = () => {
    const dispatch = useDispatch();

    const [
        bimWorkOrderChangeObjectSelectionListData,
        bimWorkOrderChangeObjectSelectionListStatus,
        bimWorkOrderChangeObjectSelectionListError,
        bimWorkOrderChangeObjectSelectionListRequest,
    ] = useRequest({
        requestId,
        query: bimWorkOrderChangeObjectSelectionListGql,
        withEffect: false,
    });

    const [bimWorkOrderChangeObjectSelectionListReset] = useResetStoreData({ requestId });

    const bimWorkOrderChangeObjectSelectionListMakeRequest = useCallback(
        (wOrderId: number, constructionTypeId?: number) => {
            if (!constructionTypeId) {
                return;
            }

            const where: BimWorkOrderChangeObjectSelectionDataFilterInput = {
                constructionType: { id: { eq: constructionTypeId } },
            };

            bimWorkOrderChangeObjectSelectionListReset(undefined);
            dispatch(bimWorkOrderChangeObjectSelectionListRequest({ workOrderChangeId: wOrderId, where }));
        },
        [bimWorkOrderChangeObjectSelectionListRequest, bimWorkOrderChangeObjectSelectionListReset, dispatch],
    );

    return {
        bimWorkOrderChangeObjectSelectionListReset,
        bimWorkOrderChangeObjectSelectionListData,
        bimWorkOrderChangeObjectSelectionListStatus,
        bimWorkOrderChangeObjectSelectionListError,
        bimWorkOrderChangeObjectSelectionListRequest,
        bimWorkOrderChangeObjectSelectionListMakeRequest,
    };
};
